export const borderRadiusRem = 0.625;
